<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>利润统计</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="search">
                        <div class="searchleft">
                            <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                                <el-form-item :label="$t('pingt')">
                                    <el-input v-model="searchform.phone" @keyup.enter.native="onSubmit" size="small" :placeholder="$t('pingt')">
                                    </el-input>
                                </el-form-item>
                                <el-form-item :label="$t('time')">
                                    <el-date-picker
                                        v-model="value1"
                                        type="datetimerange"
                                        size="small"
                                        range-separator="至"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        start-placeholder="开始时间"
                                        end-placeholder="结束时间">
                                    </el-date-picker>
                                </el-form-item>
                                <el-form-item>
                                    <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="v1" label="注册数" width="80"></el-table-column>
                        <el-table-column prop="v2" label="申请数"></el-table-column>
                        <el-table-column prop="v3" label="通过数"></el-table-column>
                        <el-table-column prop="v4" label="放款成功数"></el-table-column>
                        <el-table-column prop="v5" label="放款失败数"></el-table-column>
                        <el-table-column prop="v6" label="放款金额"></el-table-column>
                        <el-table-column prop="v7" label="还款金额"></el-table-column>
                        <el-table-column prop="v8" label="还款率"></el-table-column>
                        <el-table-column prop="v9" label="首贷数"></el-table-column>
                        <el-table-column prop="v10" label="复贷数"></el-table-column>
                        <el-table-column prop="v11" label="首贷还款率"></el-table-column>
                        <el-table-column prop="v12" label="复贷还款率"></el-table-column>
                        <el-table-column prop="v13" label="首贷分期率"></el-table-column>
                        <el-table-column prop="v14" label="一期数量/还款率"></el-table-column>
                        <el-table-column prop="v15" label="二期数量/还款率"></el-table-column>
                        <el-table-column prop="v16" label="三期数量/还款率"></el-table-column>
                        <el-table-column prop="v17" label="四期数量/还款率"></el-table-column>
                        <el-table-column prop="v18" label="五期数量/还款率"></el-table-column>
                        <el-table-column prop="v19" label="分期结清率"></el-table-column>
                        <el-table-column prop="v20" label="复贷分期率"></el-table-column>
                        <el-table-column prop="v21" label="一期数量/还款率"></el-table-column>
                        <el-table-column prop="v22" label="二期数量/还款率"></el-table-column>
                        <el-table-column prop="v23" label="三期数量/还款率"></el-table-column>
                        <el-table-column prop="v24" label="四期数量/还款率"></el-table-column>
                        <el-table-column prop="v25" label="五期数量/还款率"></el-table-column>
                        <el-table-column prop="v26" label="分期结清率"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    v1: null,
                    v2: null,
                    v3: null,
                    v4: null,
                    v5: null,
                    v6: null,
                    v7: null,
                    v8: null,
                    v9: null,
                    v10: null,
                    v11: null,
                    v12: null,
                    v13: null,
                    v14: null,
                    v15: null,
                    v16: null,
                    v17: null,
                    v18: null,
                    v19: null,
                    v20: null,
                    v21: null,
                    v22: null,
                    v23: null,
                    v24: null,
                    v25: null,
                    v26: null,
                },
                searchform: {
                    phone: "",
                },
                loading: false,
                list: [],
                value1:[],
                searchform:{},
            }
        },
        created() {
            this.getList()
        },
        methods: {
            getList() {
                this.loading = true
                _api.get(apiurl.profitStatistics, {
                    platform: this.searchform.phone,
                    time: this.value1
                }).then(res => {
                    this.loading = false
                    this.list = res.data.data
                })
            },
            onSubmit() {
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>